export enum WHETHER {
  NO,
  YES,
}

export enum TEMPLATE_SORT {
  ALL = 'score',
  NUM = 'select_num',
  NEW = 'online_time',
}

export enum CUSTOM_COVER {
  LOCAL, // 本地上传
  INTERCEPT, // 视频截取
}

// 全站搜索类型
export enum SITE_SEARCH_TYPE {
  ALL = 'all', // 全站
  HIGHLIGHT = 'product_highlights', // 产品亮点
  PERSON = 'character', // 3D数字人
  OPUS = 'templates', // 作品
  SENSE = 'scenarios', // 应用场景
  CASE = 'enterprise_cases', // 企业案例
  CLASS = 'guide', // 教程
  HELP = 'promotion_center', // 帮助中心
  SCHOOL = 'course', // 魔珐学院
}

// 用户活动枚举值
export enum USER_STATE {
  NEW_USER_ACTIVITY = 'new_user_activity', // 拉新新用户
}
